import { API_DOMAIN } from "../../constants/api";
import axios from "../fetch/fetch";

export type TrainingClassification = "CRITICAL" | "NON_CRITICAL";

const UPDATE_ASSIGNED_TRAINING_CLASSIFICATION_OVERRIDE_API = `${API_DOMAIN}/assigned/training-classification-override`;

export async function updateTrainingClassificationOverrideAPI(params: {
    assignedId: string;
    trainingClassificationOverride: TrainingClassification | null;
}): Promise<any> {
    const response = await axios.put(UPDATE_ASSIGNED_TRAINING_CLASSIFICATION_OVERRIDE_API, params);
    return response.data;
}
